// extracted by mini-css-extract-plugin
export var after = "style-module--after--76bfe";
export var after__block = "style-module--after__block--88297";
export var after__blockSec = "style-module--after__block--sec--45be1";
export var after__btn = "style-module--after__btn--d9347";
export var after__img = "style-module--after__img--f7814";
export var after__infoBlock = "style-module--after__info-block--5af2e";
export var after__item = "style-module--after__item--3db10";
export var after__itemDescr = "style-module--after__item-descr--bc448";
export var after__title = "style-module--after__title--c4e09";